import { PaperClipOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import {
    qmrsGroupedByDfmCategory_qmrsGroupedByDfmCategory_qmrs as QmrType,
    qmrsGroupedByDfmCategory_qmrsGroupedByDfmCategory_qmrs_attachmentLink_quoteAttachmentRevision_attachment as AttachmentType,
    qmrsGroupedByDfmCategory_qmrsGroupedByDfmCategory_qmrs_partRevision as PartRevisionType,
} from '@Builder/QuoteDetailPage/FilesTab/ImQuoteTabSections/ManufacturabilityFeedbackTab/__generated__/qmrsGroupedByDfmCategory'

import Box from '~/core/Box'
import FileName from '~/core/FileName'
import Image from '~/core/Image'
import formatRevisionVersion from '~/lib/formatRevisionVersion'
import getColor from '~/lib/getColor'

const tagStyle = { width: 'fit-content', fontSize: '12px' }

type PartNamePropsType = {
    attachmentFileName?: AttachmentType['fileName']
    fileName: QmrType['fileName']
    thumbnailUri: PartRevisionType['thumbnailUri']
    version: QmrType['version']
}

const PartName = (props: PartNamePropsType) => {
    const { attachmentFileName, fileName, thumbnailUri, version } = props

    return (
        <Box alignItems="center">
            <Image
                height="48px"
                src={thumbnailUri}
                style={{
                    border: `1px solid ${getColor('blackAlpha15')}`,
                    borderRadius: '4px',
                    marginRight: '8px',
                }}
                width="48px"
            />
            <Box direction="col">
                <Box marginBottom="4px">
                    <Tag style={tagStyle}>{formatRevisionVersion(version)}</Tag>
                    <FileName
                        style={{
                            fontSize: '14px',
                            fontWeight: 500,
                            whiteSpace: 'normal',
                            color: getColor('blackAlpha65'),
                        }}
                        name={fileName}
                    />
                </Box>
                {attachmentFileName && (
                    <Tag style={tagStyle}>
                        <PaperClipOutlined
                            style={{
                                marginRight: '4px',
                            }}
                        />
                        {attachmentFileName}
                    </Tag>
                )}
            </Box>
        </Box>
    )
}

export default PartName
